import { Info } from '@mui/icons-material'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import { Box, Button, Tooltip } from '@mui/material'
import DisplayPrice from 'components/Common/DisplayValues/DisplayPrice'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import Counter from 'components/RouteWizard/Counter'
import { useWizard } from 'components/RouteWizard/Wizard'
import useClient from 'hooks/useClient'
import { useState } from 'react'
import handleDestinationSupplier from '../Common/DestinationSupplierCheck'
import InformationIcon from './InformationIcon'

const VehicleCard = ({
  vehicle,
  selected = false,
  handleBookNow,
  selectMultiple = false,
  selectedVehicles,
  setSelectedVehicles,
  canSelectMoreCars = true,
  isImmediateJourney,
}: any) => {
  const { data } = useWizard()
  console.log('wizard data', data)
  console.log('vehicle', vehicle)
  const { fixedPriceDisplay, displayVATPrice } = useClient(
    data?.account?.clientId,
  )
  console.log('fixedPriceDisplay', fixedPriceDisplay)
  console.log('displayVATPrice', displayVATPrice)
  const [numOfVehicle, setNumOfVehicle] = useState<number>(0)

  const handleVehicleNegativeSelect = () => {
    if (numOfVehicle > 0) {
      setNumOfVehicle((prevValue) => {
        const newCount = prevValue - 1

        if (newCount <= 0) {
          const selectedVehiclesList = selectedVehicles
          delete selectedVehiclesList[vehicle?.supplierQuoteReference]
          setSelectedVehicles({ ...selectedVehiclesList })
        } else {
          const selectedVehiclesList = selectedVehicles
          selectedVehiclesList[vehicle?.supplierQuoteReference] = {
            supplierQuoteReference: vehicle?.supplierQuoteReference,
            inboundSupplierQuoteReference:
              vehicle?.inboundSupplierQuoteReference,
            quantity: newCount,
            price: vehicle?.price,
            estimatedPriceCurrency: vehicle?.estimatedPriceCurrency,
            seats: vehicle.vehicleDetails?.seats,
            title: VehicleDisplayName({
              vehicleDetails: vehicle.vehicleDetails,
            }),
          }
          setSelectedVehicles({ ...selectedVehiclesList })
        }

        return newCount
      })
    }
  }

  const handleVehiclePositiveSelect = () => {
    setNumOfVehicle((prevValue) => {
      const newCount = prevValue + 1
      const selectedVehiclesList = selectedVehicles
      selectedVehiclesList[vehicle?.supplierQuoteReference] = {
        supplierQuoteReference: vehicle?.supplierQuoteReference,
        inboundSupplierQuoteReference: vehicle?.inboundSupplierQuoteReference,
        quantity: newCount,
        price: vehicle?.price,
        estimatedPriceCurrency: vehicle?.estimatedPriceCurrency,
        seats: vehicle.vehicleDetails?.seats,
        title: VehicleDisplayName({
          vehicleDetails: vehicle.vehicleDetails,
        }),
      }
      setSelectedVehicles({ ...selectedVehiclesList })

      return newCount
    })
  }

  const isDestinationSupplier = () => {
    if (vehicle.isDestinationLogicQuote) {
      handleDestinationSupplier(() =>
        handleBookNow(
          vehicle?.supplierQuoteReference,
          vehicle.vehicleDetails?.seats,
          vehicle?.estimatedPriceCurrency,
          vehicle?.price,
          vehicle.vehicleDetails?.title,
          vehicle?.inboundSupplierQuoteReference,
        ),
      )
    } else {
      handleBookNow(
        vehicle?.supplierQuoteReference,
        vehicle.vehicleDetails?.seats,
        vehicle?.estimatedPriceCurrency,
        vehicle?.price,
        VehicleDisplayName({
          vehicleDetails: vehicle.vehicleDetails,
        }),
        vehicle?.inboundSupplierQuoteReference,
      )
    }
  }

  return (
    <Box
      component="div"
      sx={{
        backgroundColor: '#f0f0f0',
        color: '#0a2435',
        fontSize: '19px',
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: '#ffff',
        },
        padding: '30px',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: 'auto',
      }}
    >
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          gap: '10px',
        }}
      >
        <Box
          component="p"
          sx={{
            alignSelf: 'flex-start',
            flexGrow: 1,
            padding: '0',
            margin: '0',
          }}
        >
          {VehicleDisplayName({
            vehicleDetails: vehicle.vehicleDetails,
          })}
          {vehicle?.isDestinationLogicQuote && (
            <Tooltip title="Destination Supplier" arrow placement="top-end">
              <Info
                fontSize="medium"
                sx={(theme) => ({
                  color: theme.palette.info.dark,
                  paddingLeft: '5px',
                  verticalAlign: 'bottom',
                })}
              />
            </Tooltip>
          )}
        </Box>

        <InformationIcon
          icon={<PeopleOutlineIcon />}
          text={vehicle.vehicleDetails?.seats}
        />

        <InformationIcon
          icon={<WorkOutlineIcon />}
          text={vehicle.vehicleDetails?.luggage}
        />
      </Box>
      {vehicle.vehicleDetails?.example && (
        <Box
          component="p"
          sx={{
            fontWeight: 'light',
            fontSize: '14px',
            color: '#302f31',
            alignSelf: 'flex-start',
          }}
        >
          For example {vehicle.vehicleDetails?.example}
        </Box>
      )}
      <Box
        component="img"
        src={vehicle.vehicleDetails?.icon}
        sx={{ width: '80%' }}
      />
      <Box
        component="p"
        sx={{
          fontWeight: 'bold',
          fontSize: '28px',
          marginTop: '30px',
          marginBottom: '20px',
          color: selected ? 'var(--jy-navy-900, #00253d)' : '#0a2435',
        }}
      >
        {DisplayPrice({
          VATTotalPrice: vehicle?.price,
          priceType: fixedPriceDisplay ? 'exact' : 'range',
          displayVATPrice: displayVATPrice,
        })}
      </Box>
      {selectMultiple ? (
        <Counter
          value={numOfVehicle}
          label="vehicle"
          negativeOnClick={() =>
            numOfVehicle > 0 ? handleVehicleNegativeSelect() : null
          }
          positiveOnClick={() =>
            vehicle?.isDestinationLogicQuote
              ? handleDestinationSupplier(() => handleVehiclePositiveSelect())
              : handleVehiclePositiveSelect()
          }
          positiveDisabled={!canSelectMoreCars}
        />
      ) : (
        <Button
          sx={{
            fontSize: '18px',
            backgroundColor: '#b4b4b4',
            borderColor: '#b4b4b4',
            '&:hover': {
              backgroundColor: '#33759d',
            },
          }}
          onClick={() => isDestinationSupplier()}
        >
          {'Select & Book'}
        </Button>
      )}
      {isImmediateJourney ? (
        <Box
          component="p"
          sx={{
            fontSize: '14px',
            marginTop: '0px',
            marginBottom: '0px',
            color: selected ? 'var(--jy-navy-900, #00253d)' : '#0a2435',
          }}
        >
          eta {vehicle?.eta == 99 ? 'unavailable' : `${vehicle?.eta} minute(s)`}
        </Box>
      ) : null}
    </Box>
  )
}

export default VehicleCard
